module.exports = __webpack_public_path__ + "img/source_02.18c243dd.png";